import script from "./CommonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonModal.vue?vue&type=script&setup=true&lang=js"

import "./CommonModal.vue?vue&type=style&index=0&id=18305148&lang=css"

const __exports__ = script;

export default __exports__